export const ANSWER_SAVE_REQUEST = "ANSWER_SAVE_REQUEST";
export const ANSWER_SAVE_SUCCESS = "ANSWER_SAVE_SUCCESS";
export const ANSWER_SAVE_FAIL = "ANSWER_SAVE_FAIL";
export const ANSWER_SAVE_RESET = "ANSWER_SAVE_RESET";

export const ANSWER_LIST_REQUEST = "ANSWER_LIST_REQUEST";
export const ANSWER_LIST_SUCCESS = "ANSWER_LIST_SUCCESS";
export const ANSWER_LIST_FAIL = "ANSWER_LIST_FAIL";

export const LIKEUNLIKE_ANSWER = "LIKEUNLIKE_ANSWER";